import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Block from "../Base/Block";
import ScrollView from "../Base/ScrollView";
import View from "../Base/View";
import './index.scss'
import '../SpecificPannel/dialog.scss'

export interface MetaListPanelRef{
    open: (metaList: any[])=>void
}

const MetaListPanel = forwardRef((prop, ref) => {
    const [openType, setOpenType] = useState<number>(-1);
    const [specificList, setSpecificList] = useState<any[]>([]);

    useEffect(()=>{
        if (openType === 0) {
            setTimeout(function () {
              setOpenType(-1)
            }, 250)
          }
    }, [openType]);


    useImperativeHandle(ref, () => ({
        open: (metaList: any[]) => {
            setSpecificList(metaList);
            setOpenType(1)
        }
    }))

    return <View className="meta-list-panel">
        <View
            className={
                'pannel-msk-state-' +
                (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close')
            }
            onClick={()=>{setOpenType(0)}}
            // onTouchMove={this._consumeTouchmove}
        ></View>
        <View
            className={
                'pannel-state-' +
                (openType == -1 ? 'init' : openType != 0 ? 'open' : 'close') +
                ' pannel-inner '
            }
            // onTouchMove={this._consumeTouchmove}
        >
            <View className="pannel-title">产品参数</View>
            <ScrollView
                className="specific-list scrollbar-hide"
                scrollY={true}
                enableBackToTop={true}
                scrollWithAnimation={true}
            >
                {specificList.map((item, index) => {
                    return (
                        <View className="specific-list-item">
                            <View className="specific-name">
                                {item.SpecificationAttributeName}
                            </View>
                            <View className="specific-value">{item.ValueRaw}</View>
                        </View>
                    )
                })}
            </ScrollView>
            <View className="pannel-close-btn" onClick={()=>{
                setOpenType(0)
            }}>
                收起
            </View>
        </View>
    </View>
})

export default MetaListPanel;